export function defer(fn: () => void, selector: string) {
  if (document.querySelector(selector) !== null) {
    fn();
    return false;
  }
  setTimeout(function () {
    defer(fn, selector);
  }, 50);
}

export function deferJS(fn: () => void, validator: () => boolean) {
  if (validator()) {
    fn();
    return false;
  }
  setTimeout(function () {
    deferJS(fn, validator);
  }, 50);
}
